import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const ReminderApi = {
  getConfig: async () => {
    return httpRequest.get("/inv/reminder-config");
  },
  updateConfig: async (data: any) => {
    return httpRequest.put("/inv/reminder-config", data);
  },
  getInvoiceReminders: async (invoiceId: string) => {
    return httpRequest.get(`/inv/invoice/${invoiceId}/reminders`);
  },
  sendNow: async (invoiceId: string, data?: any) => {
    return httpRequest.post(`/inv/invoice/${invoiceId}/reminders/send-now`, data);
  },
};
